;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('coreFilterItem', coreFilterItem)

  /* @ngInject */
  function coreFilterItem () {
    return {
      restrict: 'E',
      scope: {
        params: '=',
        type: '<',
        items: '<',
        count: '<'
      },
      templateUrl: '/core/directives/core-filters/filters/core-filter-item/core-filter-item-directive.html?$$REVISION$$'
    }
  }
})()
